<h2 class="mbottom-12">Verify your academic status</h2>
<div class="row mbottom-12">
  <div class="col-12">
    <p>
      We need to verify your academic status. In case of missing or insufficient information, you authorize us to contact your academic organization for
      verification. Don't worry, we will praise you to the skies.
    </p>
    <p class="mb-0">Alternatively, if there is an academic website with your teacher/lecturer/researcher profile, enter the URL below:</p>
  </div>
</div>
<form [formGroup]="academicWebsiteForm" (yatSubmit)="submitForm($event)">
  <div class="row">
    <div class="col-12 mb-1">
      <div class="form-group no-label">
        <label class="optional">optional</label>
        <input
          type="text"
          class="form-control"
          id="website"
          formControlName="website"
          placeholder="www.starfleet.edu/se/hiro-nakamura"
          maxlength="2048"
          yatInput />
        <div class="invalid-feedback" [ngSwitch]="academicWebsiteForm.controls.website.errors | classifyValidationError">
          <span *ngSwitchCase="'looseUrl'">This doesn't seem quite right...</span>
        </div>
      </div>
    </div>
  </div>

  <yat-buttons id="9f74240a-eca1-449a-b293-2fcbbbf920fd"
    *ngIf="verifyOnContinue$ | async; else continue"
    primaryButtonName="Complete registration"
    secondaryButtonName="Back"
    (secondaryButtonClickMethod)="goBack()"
    [useYatAutoSpinner]="startAcademicVerificationActionFilter">
  </yat-buttons>
  <ng-template #continue>
    <yat-buttons id="ca23482a-74d6-47fd-afee-891a445c5477" primaryButtonName="Continue" secondaryButtonName="Back" (secondaryButtonClickMethod)="goBack()" [useYatAutoSpinner]="false"> </yat-buttons>
  </ng-template>

  <div class="row mtop-12" *ngIf="verifyOnContinue$ | async">
    <div class="col-12">
      <yat-terms-note id="d299b7b5-ce1e-42f9-a5dc-ffa7087d7643"></yat-terms-note>
    </div>
  </div>
</form>
